import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import ReactTable from 'react-table';
import { _addNotification } from '../../../server/util';
import { get } from '../../../server/actions';


class SubmitStudents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            submStudentData: [],
        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getSubmitStudentData();
    }
    getSubmitStudentData = () => {
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolId = userInfo.schoolId;
        this.setState({ loading: true })
        get(`/eseaForms/students/${schoolId}/${sessionStorage.getItem('schoolYearValue')}?access_token=`).then((resp) => {
            this.setState({ loading: false });
            console.log("Response:::::", resp);
            if (!resp.ok) {
                throw Error(resp.statusMessage);
            }
            return resp.json();
        }).then(data => {
            console.log("Data:::::", data);
            this.setState({ submStudentData: data.resp });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('submStudentData', error);
            }
        )
    }
  

    getColumns = () => {
        return [
            {
                Header: 'App Id',
                accessor: 'id',
                width: 100,
                style: { textAlign: 'center' }
            },
            {
                Header: 'Student Name',
                width: 200,
                style: { textAlign: 'center' },
                Cell: row => <span>{row.original.firstName + ' ' + row.original.lastName}</span>
            },
            {
                Header: 'Student Id',
                accessor: 'studentId',
                width: 200,
                style: { textAlign: 'center' }
            },
            {
                Header: 'Grade',
                accessor: 'grade',
                width: 200,
                style: { textAlign: 'center' }
            },
            {
                Header: 'Parent Email Id',
                accessor: "username",
                style: { textAlign: 'left' },
                width: 200,
            }
        ]
    }

    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                    <div className="row" style={{ width:'103%' }}>
                        <div className='col-md-12'>
                            <ReactTable
                                showPaginationBottom={true}
                                columns={this.getColumns()}
                                data={this.state.submStudentData}
                                defaultPageSize={3}
                                className="-striped -highlight"
                            />
                        </div>
                </div>

            </div>
        );
    }
}

export default SubmitStudents;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/EseaForm/submitStudents.js